import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  labDetails: null,
};

const viewLabSlice = createSlice({
  name: "viewLab",
  initialState,
  reducers: {
    fetchLabDetails(state, action) {
      state.loading = true;
    },
    fetchLabDetailsSuccess(state, action) {
      state.labDetails = action.payload.data.document;
      state.loading = false;
    },
    fetchLabDetailsFailure(state, action) {
      state.loading = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = viewLabSlice;
